import { useState, useEffect, useRef } from "react";
import search from '../assets/Search.svg';
import cancel from '../assets/cancel.svg';

export default function SearchBar({ onSearch }) {
    const [query, setQuery] = useState("");
    const [debouncedQuery, setDebouncedQuery] = useState("");
    const lastSearchRef = useRef("");

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedQuery(query);
        }, 500); // Adjust delay as needed (e.g., 300ms–500ms)

        return () => clearTimeout(timer); // Clear previous timer on each keystroke
    }, [query]);

    useEffect(() => {
        if (debouncedQuery === "") {
            onSearch(""); // Let parent handle clearing results
            return;
        }

        if (debouncedQuery !== lastSearchRef.current) {
            lastSearchRef.current = debouncedQuery;
            onSearch(debouncedQuery);
        }
    }, [debouncedQuery, onSearch]);

    const handleChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        // onSearch(value); // Trigger search API in parent component
    };

    return (
        <div className="search-container">
            <input
                type="text"
                placeholder="Search your word..."
                className="search-input"
                value={query}
                onChange={handleChange}
            />
            <img src={query ? cancel : search} alt="Search" className="search-icon" onClick={() => {
                if (query) {
                    setQuery("");
                    setDebouncedQuery("");
                    lastSearchRef.current = "";
                    onSearch(""); // clear results in parent
                }
            }} />
        </div>
    );
}
